export const formMixin = {
  data: {
    formInProgress: false,
  },
  methods: {
    blockUi: (el, unblock = false) => {
      if (unblock) {
        $(el).unblock();
        return;
      }
      $(el).block({
        message: '<i class="icon-spinner4 spinner"></i>',
        timeout: 30000, // unblock after 30 seconds
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent',
        },
      });
    },

    /**
     * Highlight Form Errors
     * @param data
     * @param form
     */
    formHandleErrors(data, form = null) {
      const _this = this;
      //console.error('formHandleErrors', data);

      if (data.status === 401) { // Unauthorized
        _this.notifyError(data.responseText);
        return;
      }

      if (data.status === 500) { // Exception
        _this.notifyError("Error code: "+moment().format('YYMMDD-HHmmss'));
        return;
      }

      if (data.status === 404) { // Exception
        _this.notifyError(data.responseJSON.message);
        return;
      }

      let {responseJSON: response} = data;
      let errors = [];

      if (response) {
        if (typeof response.message != 'undefined') {
          _this.notifyError(response.message);
        } else {
          _this.notifyError("Hata oluştu, lütfen formdaki hataları kontrol edip tekrar deneyin.");
        }

        if (typeof response.errors != 'undefined') {
          errors = response.errors;
        } else {
          errors = response;
        }
      }

      $.each(errors, function(key, item){
        _this.formAddErrors(key, item, form);
      });
    },

    formAddErrors(field, message, form = null) {
      const _this = this;
      if (field === 'alert') {
        _this.notifyError(message);
      }

      const fieldDotParts = field.split('.');
      if (fieldDotParts.length === 2) {
        field = fieldDotParts[0]+'\\['+fieldDotParts[1]+'\\]';
      }

      if (fieldDotParts.length === 3) {
        field = fieldDotParts[0]+'\\['+fieldDotParts[1]+'\\]\\['+fieldDotParts[2]+'\\]';
      }

      // Eğer form verilmişse, sadece onun içinde ara
      let $field;
      if (form) {
        $field = form.find("[name='"+field+"']");
      } else {
        $field = $("[name='"+field+"']");
      }

      const $fgroup = $field.closest('.form-group');
      $fgroup.addClass('has-error');
      $fgroup.append('<div class="text-danger">'+message[0]+'</div>');

      const tabid = $fgroup.closest('.tab-pane').attr('id');
      $('.nav-tabs a[href="#'+tabid+'"]').tab('show');
    },

    formClearErrors() {
      $(".has-error").removeClass('has-error').find('.text-danger').remove();
    },

    _setButtonLoading($btn, loading) {
      const $icon = $btn.find('b i');
      if (loading) {
        $btn.addClass('disabled').css('pointer-events', 'none');
        if ($icon.length) {
          $icon.data('original-class', $icon.attr('class'));
          $icon.attr('class', 'icon-spinner4 spinner');
        } else {
          $btn.prepend('<i class="icon-spinner4 spinner mr-1"></i>');
        }
      } else {
        $btn.removeClass('disabled').css('pointer-events', '');
        if ($icon.length && $icon.data('original-class')) {
          $icon.attr('class', $icon.data('original-class'));
        } else {
          $btn.find('.icon-spinner4.spinner').remove();
        }
      }
    },

    /**
     * form içindeki .decimal alanlarını bulur; her birinin orijinal değerini
     * kendi üzerinde (.data('decimal-original-value')) saklar, mask'ı söker
     * ve değerini virgülden noktaya çevirir (örn. "1500,50" -> "1500.50").
     *
     * @param form
     * @returns {jQuery} submit sonrası _restoreDecimalFields()'e geçirilecek koleksiyon
     */
    _convertDecimalFieldsToPeriod(form) {
      const $decimalFields = form.find('.decimal');

      $decimalFields.each(function () {
        const $field = $(this);
        const value = $field.val();
        $field.data('decimal-original-value', value);

        $field.inputmask('remove');
        $field.val(value ? value.toString().replace(',', '.') : value);
      });

      return $decimalFields;
    },

    /**
     * _convertDecimalFieldsToPeriod() ile geçici olarak noktaya çevrilip unmask
     * edilen alanları, orijinal virgüllü değerine döndürüp mask'ı yeniden bağlar.
     * @param $decimalFields
     */
    _restoreDecimalFields($decimalFields) {
      $decimalFields.each(function () {
        const $field = $(this);
        $field.val($field.data('decimal-original-value'));
        $field.inputmask('decimal', Mask.decimalOptions);
      });
    },

    /**
     * Form Submit helper
     * @param form
     * @param props
     * @param success
     * @param fail
     * @param always
     * @param button - Optional button element or selector to show loading state
     * @returns {boolean}
     */
    formSubmit({form = '#form', props, success, fail, always, button}) {
      const _this = this;
      if (_this.formInProgress) {
        console.error('Request already in progress.');
        return false;
      }

      if (_.isString(form)) {
        form = $(form);
      }

      if (!form || !form.length) {
        console.error('Form not found.');
        return false;
      }

      const $button = button ? $(button) : null;

      _this.formInProgress = true;
      _this.blockUi(form);
      _this.formClearErrors();

      if ($button && $button.length) {
        _this._setButtonLoading($button, true);
      }

      const $decimalFields = _this._convertDecimalFieldsToPeriod(form);

      // noinspection JSUnresolvedFunction
      $.ajax({
        url: form.prop('action'),
        method: form.prop('method'),
        data: form.serialize(),
        dataType: 'json',
        ...props,
      })
        .done(success)
        .fail((data) => {
          _this.formHandleErrors(data, form);
          if (typeof fail === "function") {
            fail(data);
          }
        })
        .always((data) => {
          _this._restoreDecimalFields($decimalFields);

          _this.formInProgress = false;
          _this.blockUi(form, true);

          if ($button && $button.length) {
            _this._setButtonLoading($button, false);
          }

          if (typeof always === "function") {
            always(data);
          }
        });

      return true;
    },
  }
};
